import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { buildGuestPresentPath } from '../utils/myEventsUrlParams';

const GuestPresentEntry = () => {
  const [searchParams] = useSearchParams();
  const linkId = searchParams.get('link') || searchParams.get('guestLink') || searchParams.get('token');

  if (!linkId) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={buildGuestPresentPath(linkId)} replace />;
};

export default GuestPresentEntry;
